export default __webpack_public_path__ + "static/2019_ESG_Annual_Progress_Report-728ccafa01c80cfb4cb61eaae4ef2aa4.pdf";